{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/IDDSI",
	"name": "IDDSI",
	"language": "nl-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "IDDSI",
	"purpose": "Evaluatie van voedsel- en drankconsistentie voor veilige slikzorg",
	"description": "IDDSI-tests zijn bedoeld om de stromings- of consistentiekenmerken van een bepaald product op het moment van testen te bevestigen. De tests moeten worden uitgevoerd op voeding en dranken onder de beoogde serveercondities (met name de temperatuur).",
	"item": [
		{
			"linkId": "30200",
			"text": "Consistentie voeding",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "vertical"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "30201",
						"display": "7. Normaal"
					}
				},
				{
					"valueCoding": {
						"code": "30202",
						"display": "EC7. Makkelijk te kauwen"
					}
				},
				{
					"valueCoding": {
						"code": "30203",
						"display": "6. Zacht en kleingesneden"
					}
				},
				{
					"valueCoding": {
						"code": "30204",
						"display": "5. Fijngemalen en smeuïg"
					}
				},
				{
					"valueCoding": {
						"code": "30205",
						"display": "4. Gladgemalen, Zeer dikvloeibaar"
					}
				},
				{
					"valueCoding": {
						"code": "30206",
						"display": "3. Dikvloeibaar"
					}
				},
				{
					"valueCoding": {
						"code": "30207",
						"display": "2. Matig vloeibaar"
					}
				},
				{
					"valueCoding": {
						"code": "30208",
						"display": "1. Licht vloeibaar"
					}
				},
				{
					"valueCoding": {
						"code": "30209",
						"display": "0. Dunvloeibaar"
					}
				}
			]
		}
	]
}
